export default "__VITE_ASSET__tWotjSLa__"